export default __webpack_public_path__ + "static/media/banner-contribution-calendar.6f29e63b.png";